const GalleryItem = ({ item, onClick }) => {
  return (
    <div className="gallery-item" onClick={onClick}>
      <div className="gallery-item-image-container">
        <img
          src={item.image}
          alt={item.title}
          className="gallery-item-image"
          loading="lazy"
        />
        <div className="gallery-item-overlay">
          <div className="gallery-item-content">
            <h3 className="gallery-item-title" data-tts="true">
              {item.title}
            </h3>
            <p className="gallery-item-description" data-tts="true">
              {item.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryItem;
